import type { SerializedStyles } from '@emotion/react';
import { css } from '@emotion/react';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('Card', [
  'base',
  'innerCard',
  'shouldHover',
]);

const cardCss: SerializedStyles = css`
  --card-border: 1px;
  --card-border-radius: var(--cds-spacing-200);
  --card-box-shadow: 0 0 40px -8px rgb(0 0 0 / 16%),
    0 0 24px -16px rgb(0 0 0 / 16%);
  --card-hover-transform: scale3d(1.03, 1.03, 1.08)
    translate3d(0.1rem, -0.25rem, 20rem);
  --card-max-width: 470px;
  --card-min-width: 230px;

  &.${classes.base} {
    background: var(--cds-color-neutral-background-primary);
    border: var(--card-border) solid
      var(--cds-color-neutral-stroke-primary-weak);
    border-radius: var(--card-border-radius);
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    justify-content: space-between;
    padding: 0;
    position: relative;
    transition: all 0.3s cubic-bezier(0, 0, 0.5, 1);
    transform: translateZ(0);
    width: 100%;

    @media (prefers-reduced-motion: reduce) {
      transition: none;
    }

    &.${classes.shouldHover} {
      &:hover {
        box-shadow: var(--card-box-shadow);
        transform: var(--card-hover-transform);
      }

      @media (prefers-reduced-motion: reduce) {
        &:hover {
          transform: none;
        }
      }
    }

    .${classes.innerCard} {
      display: flex;
      flex-direction: column;
      flex: 1;
      height: 100%;
      justify-content: space-between;
      gap: var(--cds-spacing-200);
      padding: var(--cds-spacing-100);
      position: relative;
    }
  }
`;

export default cardCss;
